<template>
  <v-row>
    <v-col xl="9" lg="9" md="12" sm="12">
  <v-card class="m-2">
    <v-card-text>
  <v-row >
    <v-col sm="4" md="2">
      <v-subheader class="c-label">Name, Vorname</v-subheader>
      <v-subheader class="c-label">Personalnummer</v-subheader>
      <v-subheader class="c-label">Eintrittsdatum</v-subheader>
      <v-subheader class="c-label">Austrittsdatum</v-subheader>
      <v-subheader class="c-label">VP-intern</v-subheader>
      <v-subheader class="c-label">VP-extern</v-subheader>
      <v-subheader class="c-label">Gesperrt</v-subheader>
      <v-subheader class="c-label">Verwaltung</v-subheader>
      <v-subheader class="c-label">Qualifikation</v-subheader>
    </v-col>
    <v-col sm="8" md="4">
      <v-text-field
          class="hide-label"
          v-model="innerItem.name"
          :rules="rules.name"
          counter
          maxlength="50"
          hint="Der Name und Vorname des Mitarbeiters"
          label="Name, Vorname"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.pers_number"
          :rules="rules.name"
          counter
          maxlength="50"
          hint="Die Personalnummer des Mitarbeiters"
          label="Personalnummer"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
      <v-dialog
          ref="dialog"
          v-model="datePickerEntry"
          :return-value.sync="innerItem.start_date"
          persistent
          width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              class="hide-label"
              :value="computedStartDate"
              label="Eintrittsdatum"
              hint="Beginndatum des Arbeitsverhältnisses"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              @click:clear="innerItem.start_date = ''"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="innerItem.start_date"
            scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="datePickerEntry = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(innerItem.start_date); $emit('change', innerItem.id)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
          ref="dialog2"
          v-model="datePickerExit"
          :return-value.sync="innerItem.end_date"
          persistent
          width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              class="hide-label"
              :value="computedEndDate"
              label="Austrittsdatum"
              hint="Enddatum des Arbeitsverhältnisses"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              @click:clear="innerItem.end_date = ''"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="innerItem.end_date"
            scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="datePickerExit = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="$refs.dialog2.save(innerItem.end_date); $emit('change', innerItem.id)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-text-field
          class="hide-label"
          v-model="innerItem.price_int"
          :rules="rules.price"
          counter
          maxlength="16"
          hint="Der interne Verrechnungspreis des Mitarbeiters"
          label="VP-intern"
          @input="$emit('change', innerItem.id)"
          suffix="€"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.price_ext"
          :rules="rules.price"
          counter
          maxlength="16"
          hint="Der externe Verrechnungspreis des Mitarbeiters"
          label="VP-extern"
          @input="$emit('change', innerItem.id)"
          suffix="€"
      ></v-text-field>
      <v-select
          class="hide-label"
          :items="selects"
          v-model="innerItem.blocked"
          label="Gesperrt"
          :disabled="!canEdit && innerItem.bis_id !== 'Neuanlage'"
          hint="Ein gesperrter Mitarbeiter wird nicht mehr angezeigt"
          @input="$emit('change', innerItem.id)"
      ></v-select>
      <v-select
          class="hide-label"
          :items="selects"
          v-model="innerItem.ginkom01"
          label="Verwaltung"
          hint="Ein Mitarbeiter der nur in der Verwaltung arbeitet"
          @input="$emit('change', innerItem.id)"
      ></v-select>
      <v-combobox
          class="hide-label"
          :items="qualifications"
          v-model="innerItem.qualification"
          label="Qualifikation"
          hint="Die Qualifikation des Mitarbeiters"
          @input="$emit('change', innerItem.id)"
      ></v-combobox>
    </v-col>
    <v-divider
        vertical
        inset
    ></v-divider>
    <v-col sm="4" md="2">
      <v-subheader class="c-label">Kostenstelle</v-subheader>
      <v-subheader class="c-label">Mitarbeitergruppe</v-subheader>
      <v-subheader class="c-label">Arbeitszeitraster</v-subheader>
      <v-subheader class="c-label">Beschäftigungsverhältnis</v-subheader>
      <v-subheader class="c-label">Wegzeit</v-subheader>
      <v-subheader class="c-label">Führerscheinklassen</v-subheader>
      <v-subheader class="c-label">Vergütungsgruppe</v-subheader>
      <v-subheader class="c-label">Erlernter Beruf</v-subheader>
      <v-subheader class="c-label">Tätigkeit im Bauhof</v-subheader>
    </v-col>
    <v-col sm="8" md="4">
      <v-select
          class="hide-label"
          :items="kosts"
          v-model="innerItem.kost"
          label="Kostenstelle"
          hint="Die Kostenstelle des Mitarbeiters"
          @input="$emit('change', innerItem.id)"
      ></v-select>
      <v-select
          class="hide-label"
          :items="kostMap[innerItem.kost]"
          v-model="innerItem.migr"
          label="Mitarbeitergruppe"
          hint="Die Mitarbeitergruppe des Mitarbeiters"
          @input="$emit('change', innerItem.id)"
      ></v-select>
      <v-select
          class="hide-label"
          :items="azras"
          v-model="innerItem.azra"
          item-text="name"
          item-value="id"
          label="Arbeitszeitraster"
          hint="Das Arbeitszeitraster des Mitarbeiters"
          @input="$emit('change', innerItem.id)"
      ></v-select>
      <v-combobox
          class="hide-label"
          :items="employmentTypes"
          v-model="innerItem.employment_type"
          label="Beschäftigungsverhältnis"
          hint="Das Beschäftigungsverhältnis des Mitarbeiters"
          @input="$emit('change', innerItem.id)"
      ></v-combobox>
      <v-text-field
          class="hide-label"
          v-model="innerItem.way_time"
          counter
          maxlength="16"
          hint="Die Zeit in Minuten, welche der Mitarbeiter von seinem Wohnsitz in die Arbeit benötigt."
          label="Wegzeit"
          @input="$emit('change', innerItem.id)"
          suffix="min"
          type="number"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.drivers_licence_class"
          counter
          maxlength="50"
          hint="Die Führerscheinklassen des Mitarbeiters"
          label="Führerscheinklassen"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.remuneration_group"
          counter
          maxlength="50"
          hint="Die Vergütungsgruppe des Mitarbeiters"
          label="Vergütungsgruppe"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.learned_profession"
          counter
          maxlength="50"
          hint="Der Erlernter Beruf des Mitarbeiters"
          label="Erlernter Beruf"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
      <v-text-field
          class="hide-label"
          v-model="innerItem.activity_at_work"
          counter
          maxlength="50"
          hint="Die Tätigkeit des Mitarbeiters im Bauhof"
          label="Tätigkeit im Bauhof"
          @input="$emit('change', innerItem.id)"
      ></v-text-field>
    </v-col>
  </v-row>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col xl="3" lg="3" md="12" sm="12">
      <v-card class="m-2">
        <v-card-title>Apps</v-card-title>
        <v-card-text>
          <v-select
              v-model="innerItem.user_apps"
              :items="appSelects"
              chips
              label="Apps für den Mitarbeiter"
              multiple
              item-text="name"
              item-value="value"
              @input="$emit('change', innerItem.id); selectedAppsChanged = true;"
          ></v-select>
          <v-list rounded dense>
            <v-list-item-group
                color="primary"
                v-model="selectedApp"
                :max="0"
            >
              <v-list-item key="tb" v-if="hasApp('tb')" @click.stop.prevent="openAppSetupDialog('tb')">
                <v-list-item-icon>
                  <img src="/img/tb_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'PS Tagesbericht Erfassung'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item key="to" v-if="hasApp('to')" @click.stop.prevent="openAppSetupDialog('to')">
                <v-list-item-icon>
                  <img src="/img/to_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'Team:o - Teamorganisator'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item key="bk" v-if="hasApp('bk')" @click.stop.prevent="openAppSetupDialog('bk')">
                <v-list-item-icon>
                  <img src="/img/bk_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'Baumkontrolle'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item key="as" v-if="hasApp('as')" @click.stop.prevent="openAppSetupDialog('as')">
                <v-list-item-icon>
                  <img src="/img/as_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'Alarmserver'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item key="6" v-if="hasApp('6')" @click.stop.prevent="openAppSetupDialog('6')">
                <v-list-item-icon>
                  <img src="/img/sp_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'Spielplatzkontrolle'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item key="kloon" v-if="hasGpsApp()" @click.stop.prevent="openAppSetupDialog('kloon')">
                <v-list-item-icon>
                  <img src="/img/kloon_logo.webp" style="height: 32px; margin-top: -4px; width: 32px; border-radius: 6px; border-width: 0; box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);"></img>                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'GPS-Nachweis PRO'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
    <setup-app-dialog ref="setup_app_dialog" :app="currentApp" :mita-gischl="innerItem.bis_id" :kloon-key="kloonKey" @success="showAppSuccess"></setup-app-dialog>
    <v-snackbar
        v-model="showSuccessMessage"
        :timeout="3000"
        right
        color="success"
    >
      <b>{{ successMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showSuccessMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="5000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>

import SetupAppDialog from "@/views/basis_data/dialogs/setup_app_dialog.vue";

export default {
  name: "mita_detail",
  components: {
    SetupAppDialog
  },
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          pers_number: '',
          kost: '',
          migr: '',
          azra: '',
          start_date: '',
          end_date: '',
          blocked: false,
          price_int: '0,00',
          price_ext: '0,00',
          ginkom01: false,
          way_time: '0',
          drivers_licence_class: '',
          remuneration_group: '',
          learned_profession: '',
          activity_at_work: '',
          qualification: '',
          employment_type: '',
          user_apps: "",
        }
      }
    },
    kostMap: {
      type: Object,
      default: () => {
        return {}
      }
    },
    kosts: {
      type: Array,
      default: () => []
    },
    azras: {
      type: Array,
      default: () => []
    },
    employmentTypes: {
      type: Array,
      default: () => []
    },
    qualifications: {
      type: Array,
      default: () => []
    },
    appSelects: {
      type: Array,
      default: () => []
    },
    kloonKey: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      innerItem: {
        id: '',
        bis_id: '',
        name: '',
        pers_number: '',
        kost: '',
        migr: '',
        azra: '',
        start_date: '',
        end_date: '',
        blocked: false,
        price_int: '0,00',
        price_ext: '0,00',
        ginkom01: false,
        way_time: '0',
        drivers_licence_class: '',
        remuneration_group: '',
        learned_profession: '',
        activity_at_work: '',
        qualification: '',
        employment_type: '',
        user_apps: [],
      },
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        kost: [val => (val || '').length > 0 || '*erforderlich'],
        price: [
          value => !!value || '*erforderlich',
          value => {
            const pattern = /^\d+(,\d{1,2})?$/
            return pattern.test(value) || 'Die Eingabe muss im Format 0,00 sein.'
          },
        ],
      },
      datePickerEntry: false,
      datePickerExit: false,
      selects: [{text: "Ja", value: true}, {text: "Nein", value: false}],
      selectedApp: null,
      currentApp: '',
      successMessage: 'Die App wurde erfolgreich eingerichtet.',
      showSuccessMessage: false,
      selectedAppsChanged: false,
      errorMessage: 'Bitte speichern Sie den Mitarbeiter zuerst.',
      showErrorMessage: false,
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.innerItem = {...newVal};
        this.selectedAppsChanged = false;
        if (this.innerItem.start_date !== '') {
          // reformate from dd.mm.yyyy to yyyy-mm-dd
          this.innerItem.start_date = this.innerItem.start_date.split(".").reverse().join("-")
        }
        if (this.innerItem.end_date !== '') {
          // reformate from dd.mm.yyyy to yyyy-mm-dd
          this.innerItem.end_date = this.innerItem.end_date.split(".").reverse().join("-")
        }
        this.innerItem.price_int = this.innerItem.price_int.replace('EU', '').replace('€').trim()
        this.innerItem.price_ext = this.innerItem.price_ext.replace('EU', '').replace('€').trim()
        this.innerItem.user_apps = this.innerItem.user_apps === '' ? [] : this.innerItem.user_apps.split("|")

      },
      deep: true
    },
  },
  computed: {
    computedStartDate () {
      return this.innerItem.start_date ? this.innerItem.start_date.split('-').reverse().join('.') : ''
    },
    computedEndDate () {
      return this.innerItem.end_date ? this.innerItem.end_date.split('-').reverse().join('.') : 'offen'
    },
  },
  mounted() {
    this.selectedAppsChanged = false;
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.innerItem = {...this.item};
    if (this.innerItem.start_date !== '') {
      // reformate from dd.mm.yyyy to yyyy-mm-dd
      this.innerItem.start_date = this.innerItem.start_date.split(".").reverse().join("-")
    }
    if (this.innerItem.end_date !== '') {
      // reformate from dd.mm.yyyy to yyyy-mm-dd
      this.innerItem.end_date = this.innerItem.end_date.split(".").reverse().join("-")
    }
    this.innerItem.price_int = this.innerItem.price_int.replace('EU', '').replace('€').trim()
    this.innerItem.price_ext = this.innerItem.price_ext.replace('EU', '').replace('€').trim()
    this.innerItem.user_apps = this.innerItem.user_apps === '' ? [] : this.innerItem.user_apps.split("|")
  },
  methods: {
    showAppSuccess() {
      console.log(this.selectedApp)
      this.selectedApp = null;
      this.showSuccessMessage = true;
    },
    hasApp(app) {
      return this.innerItem.user_apps.includes(app)
    },
    hasGpsApp() {
      return ['1', '2', '3', '10', '11', '12', '13'].some(r=> this.innerItem.user_apps.includes(r))
    },
    log() {
      console.log(this.innerItem)
    },
    openAppSetupDialog(app) {
      if (this.selectedAppsChanged) {
        this.showErrorMessage = true;
        return
      }
      this.currentApp = app;
      this.$nextTick(() => {
        this.$refs.setup_app_dialog.openDialog();
        this.selectedApp = null;
        console.log(this.selectedApp)

      })
    },
    isValid() {
      return this.innerItem.name.trim().length > 0;
    },
    resetEdit() {
      this.innerItem = {...this.item};
    },
    getData() {
      let res = {...this.innerItem};

      if (res.start_date !== '') {
        // reformate from dd.mm.yyyy to yyyy-mm-dd
        res.start_date = res.start_date.split("-").reverse().join(".")
      }
      if (res.end_date !== '') {
        // reformate from dd.mm.yyyy to yyyy-mm-dd
        res.end_date = res.end_date.split("-").reverse().join(".")
      }
      res.user_apps = res.user_apps.join("|")
      return res;
    }
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.70);
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.70);
}

::v-deep .hide-label {
  padding-top: 0px !important;
}

::v-deep .hide-label .v-label {
  display: none !important;
}

.c-label {
  margin-bottom: 10px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}

</style>
